/**
 * ПЛЕЧО A/B ЭТОЙ СБОРКИ, 2026-09-14: `a` — старый алгоритм (main), `b` — новый (feature/react-mirror).
 *
 * Метится ТО, ЧТО ЧЕЛОВЕКУ ПОКАЗАЛИ, а не что ему назначили. Сборка знает своё плечо из `VITE_AB_ARM`
 * в `.env` того checkout'а, из которого собрана, и именно его кладёт в каждое событие Amplitude
 * (`variant`) и в свойство пользователя (`ab_variant`, `$set` — состояние, не первое касание). Если
 * дверь ещё выключена и все заходят в `a`, события честно говорят `a`.
 *
 * Кто решает, какое плечо показать, — СЕРВЕР: входная дверь плеча A (server/src/ab/frontDoor.ts)
 * бросает монету для заходов без cookie, ставит HttpOnly-cookie `ab` и проксирует `b` во второй
 * процесс. В первой версии монету бросал браузер и перезагружал страницу для половины новых
 * посетителей; та механика снята в тот же день — одной механики достаточно, и лишний заход не нужен.
 *
 * Не задано — `a`: сборка без переменной ведёт себя как прод до теста.
 */
/* `c` — плечо JTBD (feature/jtbd, 2026-09-16): тот же слот и cookie, что у B, своя метка в событиях. */
export type Arm = 'a' | 'b' | 'c'

const raw = import.meta.env.VITE_AB_ARM
export const ARM: Arm = raw === 'b' || raw === 'c' ? raw : 'a'

/**
 * ИМЯ ТЕСТА, а не только буква плеча — с 2026-09-17, когда тест алгоритма закрыт и те же два слота
 * стали тестом онбординга («onboarding_1stA/B»). Буквы a/b у обоих тестов одни и те же, и без имени
 * отчёт в Amplitude за окно, накрывающее оба, складывал бы плечо B старого алгоритма с плечом B нового
 * онбординга. Имя уходит с каждым событием (`experiment`) и в свойство пользователя (`ab_experiment`),
 * чтобы любой срез резался по паре «тест × плечо». Пусто — событие без имени, как до этой правки:
 * сборки старых тестов ничего не переписывают.
 */
export const EXPERIMENT: string | null = String(import.meta.env.VITE_AB_EXPERIMENT ?? '').trim() || null
